import React, { useEffect,useCallback, Suspense, useRef } from "react";
import * as THREE from 'three'
import "./App.scss";
// import MediaQuery from 'react-responsive';
//Components
import Header from "./components/header";
import { Section } from "./components/section"

import { Canvas, useFrame } from "react-three-fiber"
import { Loader, Html,useGLTFLoader } from "drei";

import state from './components/state'
import { Block, useBlock } from "./components/blocks"


const Model = ({url}) => {
  const gltf = useGLTFLoader(url, true)
  return<primitive object={gltf.scene} dispose={null} />
}

const Lights = () =>{
  return(
    <>
      <ambientLight intensity={0.3} />
      <directionalLight position={[10,10,5]} intensity={1} />
      <directionalLight position={[0,10,0]} intensity={1.5} />
      <spotLight intensity={1} position={1000,0,0} />
    </>
  );
}

const HTMLContent = ({domContent,positionY,children,modelPath,scale}) => {
  const ref = useRef()

  const { viewportHeight } = useBlock()
  useFrame(() => {
    const curTop = state.top.current
    const curY = ref.current.rotation.y
    const nextY = (curTop / ((state.pages - 1) * viewportHeight * state.zoom * 3)) * Math.PI 

    const curpY = ref.current.position.y
    let nextpY = (curTop / ((state.pages - 1) * viewportHeight * state.zoom * 0.084)) * Math.PI + 30 //Desktop

    if(window.matchMedia('(min-width: 2000px)').matches){ // PC
      nextpY = (curTop / ((state.pages - 1) * viewportHeight * state.zoom * 0.017)) * Math.PI + 30
    }else  if(window.matchMedia('(max-width: 1000px)').matches){ // PC
      // nextpY = (curTop / ((state.pages - 1) * viewportHeight * state.zoom * 1)) * Math.PI + 30
      nextpY = (curTop / ((state.pages - 1) * viewportHeight * state.zoom * 0.00587)) * Math.PI + 30
    }else if (window.matchMedia('(min-width:500px)').matches) { // iPhone
      nextpY = (curTop / ((state.pages - 1) * viewportHeight * state.zoom * 0.0084)) * Math.PI + 30
    }

    ref.current.rotation.y = THREE.MathUtils.lerp(curY, nextY, 0.1)
    ref.current.position.y = THREE.MathUtils.lerp(curpY, -nextpY, 0.1)
  })

  return(
    <Section factor={1.5} offset={1}>
      <group position={[0,positionY,0]}>
        <mesh ref={ref} scale={scale} position={[0, -35, 0]} >
          <Model url={modelPath} />
        </mesh>
        <Html portal={domContent} fullscreen>{children}</Html>
      </group>
    </Section>
  )
}


export default function App() {
  const domContent = useRef()
  const scrollArea = useRef();
  const onScroll = (e) => (state.top.current = e.target.scrollTop);
  useEffect(() => void onScroll({ target: scrollArea.current }), []);
  

  return (
    <>
      <Header />
      <Canvas gl={{ antialias: true }} colorManagement camera={{position:[0,0,120],fov:70 }} >
        <Lights />
        <Suspense fallback={null}>
          <HTMLContent domContent={domContent} scale={[15,15,15]} positionY={250} modelPath='playingcard.gltf'>
            <div className="container">
              <h1 className="title-left">
                Playing<br />
                cards
              </h1>
              <div className="title-right">
                Playing<br />
                cards
              </div>
            </div>
          </HTMLContent>

          <HTMLContent domContent={domContent} scale={[15,15,15]} positionY={0} modelPath='playingcase.gltf'>
            <div className="container">
              <div className="title_sub">What</div>
              <div className="item">
                <div className="item-left">
                  <div className="item-left_num">01</div>
                </div>
                <div className="item-right">
                  <div className="item-right_text-title">トランプとは？</div>
                  <div className="item-right_text-text">
                    トランプとはスペード、ハートダイヤ、クラブの4種のかーどどれぞれ13枚、合計52枚(+α)の
                    カードで遊ぶ、歴史の長いカードゲームです。
                  </div>
                </div>
              </div>
            </div>
          </HTMLContent>

          <HTMLContent domContent={domContent} scale={[0.8,0.8,0.8]} positionY={-250} modelPath='playingcase.gltf'>
            <div className="container">
              <div className="title_sub">origine</div>
              <div className="item">
                <div className="item-left">
                  <div className="item-left_num">02</div>
                </div>
                <div className="item-right">
                  <div className="item-right_text-title">起源</div>
                  <div className="item-right_text-text">
                    起源は諸説あり、「古代エジプト起説」と「インド起源説」と「中国起源説」が存在する。
                    この中でも、もっとも有力な説が「中国起源説」である。
                  </div>
                </div>
              </div>
              <div className="item-content">
                <div className="item-content-list">
                  <div className="item-right_text-title">インド起源説</div>
                  <div className="item-right_text-text">
                    チェスとともに6世紀ごろのインドで発祥したとする説。ジプシーが7世紀ごろにインドから欧州に伝来したとされるが、信憑性は薄いとされている。力な説が「中国起源説」である。
                  </div>
                </div>
                <div className="item-content-list">
                  <div className="item-right_text-title">中国説</div>
                  <div className="item-right_text-text">
                    12世紀以前の中国に「葉子(馬弔・マーディアオ)」というカードゲームがあったことから、これが欧州に伝わりプレイングカード(トランプ)とされているのではないか言われている説。この「葉子」は今日では「麻雀」の元になった遊びとされている。
                  </div>
                </div>
                <div className="item-content-list">
                  <div className="item-right_text-title">古代エジプト起源説</div>
                  <div className="item-right_text-text">
                    古代エジプトの神秘哲学がタロットというトランプに表象されていることから非常に古くからエジプトにトランプがあったとする説。しかし近年の研究で、現存する最古のタロットカードよりも古いトランプの現物や記録が存在することなどから、タロットの方がプレイングカードから派生したと考えられ、この説に関しては現在は否定的な意見が多く、最近ではタロットと古代エジプトの関係も否定されている。
                  </div>
                </div>
              </div>
            </div>
          </HTMLContent>

          <HTMLContent domContent={domContent} scale={[0.8,0.8,0.8]} positionY={-500} modelPath='playingcase.gltf'>
            <div className="container">
              <div className="title_sub">INTRODUCED</div>
              <div className="item">
                <div className="item-left">
                  <div className="item-left_num">03</div>
                </div>
                <div className="item-right">
                  <div className="item-right_text-title">欧州への伝来</div>
                  <div className="item-right_text-text">
                  起源が定まっていないことから欧州への伝来についても諸説あるが、少なくとも14世紀には欧州各地に記録が見られることから相当数広まっていたと考えられる。欧州に最初にトランプが出現したのは14世紀前半のイタリアとされているが、スペイン説も有力。

                  15世紀も後半になると、フランスではスートがダイヤ(♢)、スペード(♤)、ハート(♡)、クラブ(♧)に変わり、絵札の騎士が女王と差し替えられた。valet, dame, roiとなった。

                  このフランススタイルがイギリスに渡り、valetがjackに、dameがqueenに、roiがkingになり、英語圏に広がってゆくことになった。

                  フランスにおいて、フランス革命期には、王は守護神（Génie）、女王は自由（Liberté）、ジャックは平等（Égalité）に置き換わった。これは王政復古くらいまで続いた。
                  </div>
                </div>
              </div>
            </div>
          </HTMLContent>

          <HTMLContent domContent={domContent} scale={[0.8,0.8,0.8]} positionY={-750} modelPath='playingcase.gltf'>
            <div className="container">
              <div className="title_sub">DESIGN</div>
              <div className="item">
                <div className="item-left">
                  <div className="item-left_num">04</div>
                </div>
                <div className="item-right">
                  <div className="item-right_text-title">デザイン</div>
                  <div className="item-right_text-text">
                    フランスのデッキで最も人気のある標準パターンは英語のパターンで、国際パターンまたは英米パターンと呼ばれることもあります。

                    最新のトランプは、カードが重なっているときにカードを識別しやすくし、反対側のプレーヤーにとって同じように見えるように、反対側のコーナーまたは4つのコーナーすべてにインデックスラベルが付いています。
                    コートカードの場合、これは最初の文字またはそのカードの名前からの文字で構成されます。英語の国では、エース、キング、クイーン、ジャックを表すA、K、Q、Jの文字が付けられています。他の国では、文字が異なる場合があります。ドイツではA、K、D、B（As、König、Dame、Bube）を使用しています。ロシアはT、K、D、B（Tuz、Korol、Dama、Valet）を使用しています。スウェーデンはE、K、D、Kn（Ess、Kung、Dam、Knekt）、フランスでは1、R、D、V（1、Roi、Dame、Valet）を使用しています。
                  </div>
                </div>
              </div>
            </div>
          </HTMLContent>

          <HTMLContent domContent={domContent} scale={[0.8,0.8,0.8]} positionY={-1000} modelPath='playingcase.gltf'>
            <div className="container">
              <div className="title_sub">ACE design</div>
              <div className="item">
                <div className="item-left">
                  <div className="item-left_num">05</div>
                </div>
                <div className="item-right">
                  <div className="item-right_text-title">スペードのエースのデザイン</div>
                  <div className="item-right_text-text">
                    英国のカードとそれに倣っているカードでは、スペードのエースのカードに製作者が書かれ、その中央のスペードマークのみダイヤ・クラブ・ハートのそれと比べて大きく、また凝った模様が施されているものも多い。この由来は、イングランド王ジェームズ1世の時代まで遡る。トランプのカードに、1パッケージあたり幾らという形で税金が掛けられたため、その支払いの証拠として、出荷時にパックの一番表側に置かれる慣習であるスペードのエースに、偽造防止の目的で複雑な模様の納税証明印が押された。これがデザインとしてカードの側に転移したものである。英国ではその後、1960年8月4日までStamp Act 1765（en:Stamp Act 1765）によりトランプは課税されていた。
                  </div>
                </div>
              </div>
            </div>
          </HTMLContent>

        </Suspense>
      </Canvas>
      <Loader />
      <div className="scrollArea" ref={scrollArea} onScroll={onScroll}>
        <div style={{ position: "sticky", top: 0 }} ref={domContent} />
        <div style={{ height: `${state.pages * 100}vh` }} />
      </div>
    </>
  );
}

